import * as types from "../constants/actionConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import * as groupType from "../constants/groupTypeLikertOrDefault";
import TemplateApi from "../api/TemplateApi";
import * as TEMPLATE from "../constants/templateConstants";
import {createEditorInstanceId, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";


export function initializeGroupEditorCreate(template) {

    if (!template) {
        template = {
            metadata: {}
        };
    }

    return {
        type: types.GROUP_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.GROUP),
            template: {
                answerOptionTemplates: [],
                templateKey: (template.templateKey)? template.templateKey : "",
                name: (template.name)? template.name : "",
                nameQualifier: (template.nameQualifier) ? template.nameQualifier : null,
                description: (template.description)? template.description : "",
                script: "",
                metadata: {...template.metadata},
                questionGroupType: (template.questionGroupType)? template.questionGroupType : groupType.GROUP_TYPE_DEFAULT,
                questionKeys: [],
                showGroupKeys: [],
                visible: true
            },
            questionKeys: [],
            options: {
                hasScript: false,
                hasDescription: false,
                createMode: true,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function initializeGroupEditorEdit(template) {
    return {
        type: types.GROUP_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.GROUP),
            template: template,
            questionKeys: template.questionKeys,
            showGroupKeys: [],
            options: {
                hasScript: !!template.script,
                hasDescription: !!template.description,
                createMode: false,
                validate: [],
                isValidating: false
            }
        }
    };
}


export function updateGroupTemplate(template, options) {
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_UPDATE, payload: {template, options}});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function clearGroupEditor() {
    return (dispatch) => {
        dispatch({type: types.CLEAR_GROUP_GRAPH});
        dispatch({type: types.GROUP_EDITOR_CLEAR});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function setGroupLikertMode(template, isLikert) {
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_UPDATE_TYPE, questionGroupType: isLikert ? groupType.GROUP_TYPE_LIKERT : groupType.GROUP_TYPE_DEFAULT});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function validateGroupNameAndQualifierUnique(name, qualifier) {
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_NAME_AND_QUALIFIER_VALIDATING});
        dispatch(validateGroupNameAndQualifierExists(name, qualifier));
    };
}


export function validateGroupNameAndQualifierExists(name, qualifier) {

    let nameQualifier = qualifier === null ? "" : qualifier;

    let thunk = (dispatch) => {
        TemplateApi.checkTemplateNameAndQualifierExists(TEMPLATE.TYPE.GROUP, name, nameQualifier).then((data) => {
            dispatch({type: types.GROUP_EDITOR_NAME_AND_QUALIFIER_EXISTS, list: data.collection, depth: 0});
        });
    };

    thunk.meta = {
        debounce: {
            time: 1000,
            key: "__groupExistsCheck",
            leading: false,
            trailing: true
        }
    };

    return thunk;
}

// ---------------------------------------------------------------------------------------------------------------------
// Groups LIKERT and NON-LIKERT will have associated questions
// ---------------------------------------------------------------------------------------------------------------------

export function addGroupQuestion(questionKey) {
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_ADD_QUESTION, questionKey: questionKey});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function setGroupShowGroupKeys(removedQuestionKey, showGroupKeys = []) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_SET_SHOW_GROUP_KEYS, removedQuestionKey: removedQuestionKey, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function removeGroupQuestion(index) {
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_REMOVE_QUESTION, index: index});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function reorderGroupQuestion(isUp, currentIndex, template) {
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_REORDER, isUp: isUp, currentIndex: currentIndex});
        dispatch({type: types.GROUP_EDITOR_UPDATE, payload: {template}});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Questions show group keys
// ---------------------------------------------------------------------------------------------------------------------

export function addGroupShowGroupKeys(template, showGroupKeys = []) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.GROUP_EDITOR_ADD_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

